class Works {
  constructor() {
		const workSwiperEl = document.querySelector('.js-other-works-swiper');

		if (!workSwiperEl) {
			return;
		}

		let swiper = null;
		let fitsAll = null;

		const getOriginalSlides = () =>
			Array.from(workSwiperEl.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)'));

		const allSlidesFit = () => {
			const slides = getOriginalSlides();
			if (!slides.length) {
				return true;
			}

			const spaceBetween = 20;
			const totalWidth = slides.reduce(
				(sum, slide, i) => sum + slide.offsetWidth + (i < slides.length - 1 ? spaceBetween : 0),
				0
			);

			return totalWidth <= workSwiperEl.clientWidth + 1;
		};

		const updatePagination = (instance) => {
			const total = instance.params.loop
				? instance.slides.filter((slide) => !slide.classList.contains('swiper-slide-duplicate')).length
				: instance.slides.length;

			workSwiperEl.querySelector('.js-other-works-total').textContent =
				String(total).padStart(2, '0');
			workSwiperEl.querySelector('.js-other-works-now').textContent =
				String(instance.realIndex + 1).padStart(2, '0');
		};

		const initSwiper = () => {
			const nextFitsAll = allSlidesFit();

			if (swiper && fitsAll === nextFitsAll) {
				swiper.update();
				return;
			}

			fitsAll = nextFitsAll;
			workSwiperEl.classList.toggle('is-slides-fit', fitsAll);

			if (swiper) {
				swiper.destroy(true, true);
				swiper = null;
			}

			swiper = new Swiper(workSwiperEl, {
				// 幅はCSS固定（PC:35×45 / SP:26.4×40）のため auto で縦横比を維持
				slidesPerView: 'auto',
				centeredSlides: true,
				spaceBetween: 20,
				loop: false,
				loopFillGroupWithBlank: true,
				watchOverflow: true,
				allowTouchMove: !fitsAll,
				breakpoints: {
					768: fitsAll
						? {
								loop: false,
								slidesPerView: 'auto',
								spaceBetween: 20,
								centeredSlides: false,
								slidesOffsetAfter: 0,
							}
						: {
								loop: true,
								slidesPerView: 'auto',
								spaceBetween: 20,
								centeredSlides: false,
								slidesOffsetAfter: 900,
							}
				},

				navigation: {
					prevEl: '.js-other-works-prev',
					nextEl: '.js-other-works-next'
				},

				on: {
					init: function () {
						updatePagination(this);
					},

					slideChange: function () {
						workSwiperEl.querySelector('.js-other-works-now').textContent =
							String(this.realIndex + 1).padStart(2, '0');
					},
				}
			});
		};

		initSwiper();
		window.addEventListener('resize', initSwiper);
	}
}
